import { PATH_PAGE_ITERATION_SYMBOL } from '../../class/stateful-value.class';
import { WorkflowPage } from '../../class/workflow.type';

export const isIterativePath = (path: string): boolean => {
  return path.indexOf(PATH_PAGE_ITERATION_SYMBOL) > -1;
};

export const isIterativePage = (page: WorkflowPage): boolean => {
  return isIterativePath(page.path);
};
